import React from 'react'
import SALink from 'components/SALink'
import { Serif } from 'components/Serif'
import LocaleCurrency from 'components/FormatPrice/LocaleCurrency'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import { Dimensions } from 'components/MeasurementUnit'
import { TransformedArtwork, ImageProps } from 'types/Artwork'
import { ArtworkText } from './styles/artwork'
import OriginalPrice from './OriginalPrice'
import classNames from 'classnames'
import { capitalizeString } from 'lib/helpers'

type Props = TransformedArtwork & ImageProps & Record<string, any> // Renders a carousel of additional artworks by the artist.

export default (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    artistName,
    artworkId,
    clickArtwork,
    country,
    dataApi,
    dataList,
    dataPosition,
    dimensions,
    isSeoValid,
    minPrintPrice,
    productPage,
    productUrl,
    profileUrl,
    title,
    category,
    dataListId,
  } = props
  const capitalizedArtistName = capitalizeString(artistName)
  const isCountryHidden = [
    'more-from-artist-pdp',
    'visually-similar-pdp',
    'you-may-also-like-pdp',
  ].some((carouselSection) => carouselSection.includes(dataListId))

  return (
    <ArtworkText>
      <SALink
        data-api={dataApi}
        data-id={artworkId}
        data-position={dataPosition}
        data-list={dataList}
        data-category={category}
        data-type='title'
        href={productPage}
        onClick={clickArtwork}
        onKeyUp={clickArtwork}
        title={`${title || ''} by ${capitalizedArtistName || ''}`}
      >
        <h6 className={classNames('defaultTypographyH6', 'defaultTextTruncate')}>
          {capitalizeString(title)}
        </h6>
      </SALink>

      <p className={classNames('defaultTypographyXSmall', 'defaultTextTruncate')}>
        <Dimensions {...{ dimensions }} />
      </p>

      {country && !isCountryHidden && (
        <p
          className={classNames('defaultTypographySmall', 'defaultTextTruncate')}
          data-type='country'
        >
          {country || ''}
        </p>
      )}

      <SALink data-type='artist' href={profileUrl} title={`${capitalizedArtistName || ''} profile`}>
        <p className={classNames('defaultTypographySmall', 'defaultTextTruncate')}>
          {capitalizedArtistName}
        </p>
      </SALink>
      <div>
        <Serif data-type='price'>
          <p className='defaultTypographySmall'>
            {/* Show price if available */}
            <OriginalPrice {...props} />
          </p>
        </Serif>

        {/* Show min print price if available  */}
        {minPrintPrice && (
          <Serif data-type='prints'>
            <SALink
              href={productUrl}
              onClick={clickArtwork}
              onKeyUp={clickArtwork}
              rel={isSeoValid ? null : 'nofollow'}
              title={`Prints of ${title || ''}`}
            >
              <p className='defaultTypographySmall'>
                Prints from{' '}
                <LocaleCurrency price={convertFromCentsToDollars(Number(minPrintPrice))} />
              </p>
            </SALink>
          </Serif>
        )}
      </div>
    </ArtworkText>
  )
}
